import { withTranslation } from 'react-i18next';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { MATCH_POLICIES, MATCH_POLICY } from '../brand';

/**
 * This report's own scope control: how the brand terms become the expression Search Console is
 * sent.
 *
 * The two policies are not a convenience setting, they are two different promises. Literal means
 * this app builds the expression and can therefore say exactly what it matched; advanced means
 * the user's expression is forwarded verbatim, in a language — RE2 — that is close enough to
 * JavaScript's regular expressions to mislead and different enough to reject patterns that look
 * fine here. The field says so rather than letting a rejected pattern come back as an unexplained
 * request failure.
 */
function ExtraControls({ t, draft, onChange }) {
    const policyOptions = MATCH_POLICIES.map((value) => ({
        value,
        label: t(`tools.brand_non_brand.policies.${value}`),
    }));

    return (
        <>
            <div className="gsc-tool-field">
                <label>{t('tools.brand_non_brand.controls.policy')}</label>
                <ReactSelect
                    options={policyOptions}
                    value={policyOptions.find((item) => item.value === draft.policy)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ policy: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t(`tools.brand_non_brand.controls.policy_note.${draft.policy}`)}
                </span>
            </div>

            {draft.policy === MATCH_POLICY.REGEX && (
                <div className="gsc-tool-field gsc-tool-field-wide">
                    <label htmlFor="bnb-pattern">
                        {t('tools.brand_non_brand.controls.pattern')}
                    </label>
                    <input
                        id="bnb-pattern"
                        type="text"
                        className="form-control"
                        value={draft.pattern}
                        placeholder={t('tools.brand_non_brand.controls.pattern_placeholder')}
                        onChange={(event) => onChange({ pattern: event.target.value })}
                    />
                    <span className="gsc-tool-field-note">
                        {t('tools.brand_non_brand.controls.pattern_note')}
                    </span>
                </div>
            )}
        </>
    );
}

export default withTranslation()(ExtraControls);
